import PropTypes from 'prop-types';
import React from 'react';

import { componentFactory } from '@powdr/utils';

import { StyledColumnGroup } from './styles';

export const ColumnGroup = ({
  className = '',
  is5050 = false,
  parentColorProfile = null,
  relationships,
}) => (
  <StyledColumnGroup className={`${className} column-group`}>
    {componentFactory(relationships?.components, parentColorProfile, undefined, { is5050 })}
  </StyledColumnGroup>
);

ColumnGroup.propTypes = {
  className: PropTypes.string,
  parentColorProfile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  relationships: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  is5050: PropTypes.bool,
};
